import './index.css';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import classnames from 'classnames';
import '@hh.ru/magritte-common-focus-visible';
import { useDisabled } from '@hh.ru/magritte-common-use-disabled';
import { s as styles, A as ActionSkeleton } from './Skeleton-Bcfbr-m6.js';
import { ComponentWithBadge } from '@hh.ru/magritte-ui-badge';
import { enrichWithSkeleton } from '@hh.ru/magritte-ui-skeleton';
import '@hh.ru/magritte-common-use-loading-state';

const ALLOWED_BADGE_SIZES = ['small', 'extra-small'];
const ActionComponent = forwardRef(({ style = 'neutral', pressedStyle, hoverStyle, mode = 'primary', icon, showBackground = false, onClick, disabled, disablePadding = false, badge, 'data-qa': dataQa, ...rest }, ref) => {
    const IconComponent = icon;
    const forceDisabled = useDisabled();
    const isComponentDisabled = !!disabled || forceDisabled;
    const action = (jsx("button", { ...rest, ref: ref, type: "button", onClick: onClick, className: classnames(styles.action, styles[`action-mode-${mode}`], styles[`action-style-${style}`], styles[`action-hover-style-${hoverStyle || style}`], styles[`action-pressed-style-${pressedStyle || style}`], {
            [styles.actionShowBackground]: showBackground && !disablePadding,
            [styles.actionDisablePadding]: disablePadding,
        }), disabled: isComponentDisabled, "data-qa": dataQa, children: jsx(IconComponent, {}) }));
    if (!badge || isComponentDisabled) {
        return action;
    }
    return (jsx(ComponentWithBadge, { allowedSizes: ALLOWED_BADGE_SIZES, badge: badge, offset: disablePadding ? -3 : 5, children: action }));
});
ActionComponent.displayName = 'Action';
const ActionWithFlag = ActionComponent;
ActionWithFlag.isAction = true;
const Action = enrichWithSkeleton(ActionComponent, ActionSkeleton);

export { Action, ActionComponent };
//# sourceMappingURL=Action.js.map
